// Site Header

import './index.scss';

export default class SiteHeader {
  constructor(root) {
    this.root = root;

    this.scrollBefore = 0;
    this.scroll();
  }

  scroll() {
    let scrollCurrent = window.pageYOffset;

    if (!window.pageTypeJoboffer && !window.siteNavMenuShown && !window.siteNavSlideoutShown) {
      let scrollDiff = this.scrollBefore - scrollCurrent;

      let height = this.root.offsetHeight;
      let offset = parseInt(window.getComputedStyle(this.root).top) + scrollDiff;

      offset = Math.max(offset, - height);
      offset = Math.min(offset, 0);
      if (scrollCurrent < 250) {
        offset = 0;
      }
      this.root.style.top = offset + 'px';
    }

    this.scrollBefore = scrollCurrent;
  }
}
